import Totals from '@vue-storefront/core/modules/cart/types/Totals'

const applyOptions = (item: Totals) => {
  if (item.options && typeof item.options === 'string') {
    return { ...item, options: JSON.parse(item.options) }
  }

  return item
}

const reduceToObject = (previousValue: any, currentValue: Totals) => ({
  ...previousValue,
  [currentValue.item_id]: currentValue
})

const prepareShippingInfoForUpdateTotals = (totals: Totals[]) =>
  totals
    .map(applyOptions)
    .reduce(reduceToObject, {})

export default prepareShippingInfoForUpdateTotals
